<template>
	<div class="trade-cashback-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.title.one') }}
					<strong>
						{{
							$t('new_ui.personal_trade_cashback_page_v2.sec_01.title.two')
						}} </strong
					><br />
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.title.three') }}
				</h2>
				<p>
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.desc.one')
					}}<br />
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.desc.two') }}
					<br />
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.desc.three') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.btn.one') }}
					</a>
					<a href="#" @click="showComingSoon" class="btn-type-02">
						{{ $t('new_ui.personal_trade_cashback_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-09">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_09.title.one')
					}}<br />
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_09.title.two') }}
				</h3>
				<p>
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_09.one.desc.one')
					}}<br />
					{{ $t('new_ui.personal_trade_cashback_page_v2.sec_09.one.desc.two') }}
					<br />
					{{
						$t('new_ui.personal_trade_cashback_page_v2.sec_09.one.desc.three')
					}}
				</p>
			</div>
		</section>
		<section class="sec-03">
			<div class="container-box">
				<div class="txt-img-box">
					<div class="txt-box">
						<h3>
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.title.one',
								)
							}}<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.title.two',
								)
							}}
						</h3>
						<p>
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.desc.one',
								)
							}}<br />{{
								$t('new_ui.personal_trade_cashback_page_v2.sec_03.one.desc.two')
							}}
							<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.desc.three',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.desc.four',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.one.desc.five',
								)
							}}
						</p>
						<a href="#" @click="showComingSoon" class="btn-type-02">
							{{ $t('new_ui.personal_trade_cashback_page_v2.sec_03.one.btn') }}
						</a>
					</div>
					<div class="img-box">
						<img :src="img.imgTradecashbackSec0301" alt="" />
					</div>
				</div>
				<div class="txt-img-box">
					<div class="img-box">
						<img :src="img.imgTradecashbackSec0302" alt="" />
					</div>
					<div class="txt-box">
						<h3>
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.two.title.one',
								)
							}}
						</h3>
						<p>
							{{
								$t('new_ui.personal_trade_cashback_page_v2.sec_03.two.desc.one')
							}}
							<br />
							{{
								$t('new_ui.personal_trade_cashback_page_v2.sec_03.two.desc.two')
							}}
							<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.two.desc.three',
								)
							}}
							<br />
							{{
								$t(
									'new_ui.personal_trade_cashback_page_v2.sec_03.two.desc.four',
								)
							}}
						</p>
						<a href="#" @click="showComingSoon" class="btn-type-02">
							{{ $t('new_ui.personal_trade_cashback_page_v2.sec_03.two.btn') }}
						</a>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import imgTradecashbackSec0301 from '@/assets/images/v2/img-tradecashback-sec-03-01.png';
import imgTradecashbackSec0302 from '@/assets/images/v2/img-tradecashback-sec-03-02.png';

export default {
	data: () => {
		return {
			img: {
				imgTradecashbackSec0301,
				imgTradecashbackSec0302,
			},
		};
	},
	methods: {
		showComingSoon() {
			alert(
				this.$t('new_ui.personal_trade_cashback_page_v2.common.coming_soon'),
			);
		},
	},
};
</script>
